import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ t("path", { d: "M8.007 8.021a2.267 2.267 0 1 1 .001-4.534 2.267 2.267 0 0 1-.001 4.534Zm0-3.164a.91.91 0 0 0-.907.907.91.91 0 0 0 .907.906.91.91 0 0 0 .906-.906.91.91 0 0 0-.906-.907Z" }, null, -1), a = /* @__PURE__ */ t("path", { d: "M8.007 15.49c-.464 0-.89-.232-1.131-.62l-3.49-5.413c-1.19-1.701-1.363-3.847-.474-5.742C3.772 1.878 5.484.69 7.485.525a9.23 9.23 0 0 1 1.034 0c2.001.164 3.712 1.353 4.573 3.19a5.712 5.712 0 0 1-.484 5.752l-3.48 5.404a1.326 1.326 0 0 1-1.13.618h.009Zm.01-13.534c-.136 0-.271 0-.407.019-1.479.116-2.735.996-3.383 2.359a4.267 4.267 0 0 0 .358 4.302s.01.019.019.019l3.403 5.288 3.403-5.288a4.264 4.264 0 0 0 .377-4.321C11.149 2.97 9.882 2.09 8.413 1.975c-.136-.01-.27-.02-.406-.02h.01Z" }, null, -1), l = [
  n,
  a
];
function s(r, d) {
  return e(), o("svg", c, [...l]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
